var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-range-custom-plugin',{attrs:{"initRange":_vm.dateRange,"captions":_vm.captions,"months":_vm.months,"shortDays":_vm.shortDays,"format":_vm.format,"righttoleft":true,"hasDateToUse":_vm.hasDateToUse,"initDateToUse":_vm.dateToUse,"dateToUseOptions":_vm.dateToUseOptions},on:{"applyrange":_vm.applyRange,"cleardaterange":_vm.resetRange}})
}
var staticRenderFns = []

export { render, staticRenderFns }